const fetchPostalCode = (coordinates, country, language, v3ServicesPath) => {
  const { latitude, longitude } = coordinates;
  const url = `${v3ServicesPath}/geo/postal-code/${language}/${country}?latitude=${latitude}&longitude=${longitude}`;
  return fetch(url)
    .then((response) => response.json())
    .then((data) => data.postalCode)
    .catch(() => null);
};

export default fetchPostalCode;
